import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import { minTablet, minDesktop } from '../styles/breakpoints';
import {
  DESKTOP_MARGIN,
  DESKTOP_WIDTH,
  TABLET_MARGIN,
  PHONE_MARGIN,
} from '../styles/pageLayout';

const Layout = styled.div`
  margin-left: auto;
  margin-right: auto;

  padding: 0 ${PHONE_MARGIN}px;

  ${minTablet} {
    padding: 0 ${TABLET_MARGIN}px;
  }

  ${minDesktop} {
    max-width: ${DESKTOP_WIDTH + (DESKTOP_MARGIN * 2)}px;
    padding: 0 ${DESKTOP_MARGIN}px;
  }
`;

const PageLayout = ({ className, children }) => (
  <Layout className={className}>
    { children }
  </Layout>
);

PageLayout.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

PageLayout.defaultProps = {
  className: undefined,
};

export default PageLayout;



// WEBPACK FOOTER //
// ./src/components/PageLayout/PageLayout.js